@if (hasErrored()) {
  <div class="invalid-data-text">{{ 'global.dataLoadError' | translate }}</div>
} @else if (noDataToDisplay()) {
  <div class="invalid-data-text">{{ 'charts.noChartData' | translate }}</div>
} @else {
  @if (chartOptions) {
    <div class="chart-container">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [stroke]="chartOptions.stroke"
        [fill]="chartOptions.fill"
        [grid]="chartOptions.grid"
        [tooltip]="chartOptions.tooltip"
        [dataLabels]="chartOptions.dataLabels"
      >
      </apx-chart>
    </div>
  }
}
